import { PublicNav, PublicFooter } from "@/components/app/PublicNav";
import { BarChart3, Calculator, FileText, Leaf, ShieldCheck, ClipboardCheck, LineChart, Users2, DatabaseBackup, Sparkles } from "lucide-react";

const items = [
  { icon: Calculator, t: "Perhitungan HPP Standar & Aktual", d: "Full costing lengkap dengan varians harga dan kuantitas." },
  { icon: Leaf, t: "Green Accounting", d: "Kategori biaya lingkungan dapat dikonfigurasi, mendukung mode HPP dan pelaporan." },
  { icon: LineChart, t: "Dashboard Analitik", d: "KPI biaya, komposisi biaya, dan tren HPP bulanan." },
  { icon: ClipboardCheck, t: "Persetujuan Berjenjang", d: "Alur draft → review → disetujui → diposting → dikunci." },
  { icon: ShieldCheck, t: "Multi-Tenant & RBAC", d: "Tujuh peran dengan pengecekan otorisasi di sisi server." },
  { icon: FileText, t: "Ekspor PDF & Excel", d: "Laporan HPP dan produksi siap cetak dengan identitas perusahaan." },
  { icon: BarChart3, t: "Simulasi Harga Jual", d: "Metode markup atau margin, sensitivitas dan pembulatan." },
  { icon: Users2, t: "Kolaborasi Tim", d: "Undang pengguna per organisasi, atur peran, kelola akses." },
  { icon: DatabaseBackup, t: "Audit Trail", d: "Setiap perubahan tersimpan lengkap dengan pelaku, waktu, dan alasan." },
  { icon: Sparkles, t: "UX yang Ramah", d: "Antarmuka Bahasa Indonesia yang jelas, aksesibel, dan responsif." },
];

export default function Features() {
  return (
    <div className="min-h-screen bg-slate-50">
      <PublicNav />
      <section className="max-w-6xl mx-auto px-6 py-16">
        <span className="gc-label">Fitur</span>
        <h1 className="gc-h1 mt-3">Lengkap untuk kebutuhan akuntansi produksi & pelaporan hilirisasi.</h1>
        <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((i) => (
            <div key={i.t} className="gc-card group hover:-translate-y-1 transition-transform">
              <div className="inline-flex h-11 w-11 rounded-xl bg-emerald-50 border border-emerald-100 items-center justify-center text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white transition-colors">
                <i.icon className="w-5 h-5" />
              </div>
              <h3 className="gc-h3 mt-4">{i.t}</h3>
              <p className="text-sm text-slate-600 mt-2">{i.d}</p>
            </div>
          ))}
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
